import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20abstract%20background%20with%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20subtle%20gradient%2C%20soft%20glowing%20accents%2C%20minimal%20artistic%20composition%2C%20elegant%20modern%20style%2C%20flowing%20organic%20shapes%2C%20professional%20background%20design%2C%20rich%20texture%2C%20moody%20ambient%20lighting%2C%20no%20text&width=1600&height=700&seq=cta-bg-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="relative min-h-[300px] md:min-h-[350px]">
            <h2 className="absolute top-0 left-0 text-4xl md:text-6xl lg:text-7xl font-black text-background-50 font-heading leading-none max-w-lg">
              开始你的
              <br />
              韩漫之旅
            </h2>

            <Link
              to="/category/romance"
              className="absolute bottom-0 left-0 inline-flex items-center gap-3 whitespace-nowrap px-6 py-3 bg-background-50 text-foreground-950 text-sm font-semibold rounded-full hover:bg-background-200 transition-all cursor-pointer group"
            >
              <span>立即阅读</span>
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>

            <div className="absolute bottom-0 right-0 max-w-xs text-right">
              <p className="text-sm md:text-base text-background-200/70 leading-relaxed">
                超过{''}5000部{''}精选韩漫，
                <br />
                全部免费在线阅读
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}